
import { useQuery } from "@tanstack/react-query";
import { remesasXBodegaYProducto } from "../../../services";





export const useRemesasXBodegaYProducto = (id) => {

    const { data, isLoading } = useQuery({
        queryKey: ['remesas-xbodegaproducto', id], 
        queryFn: () => remesasXBodegaYProducto(id),
    });

    return { data, isLoading }
}

